import { z } from 'zod';
import { paginatedSchema, paginationQuerySchema } from '../common/pagination.schema.js';
import { authEventTypes } from './auth-event-types.js';

export const authEventTypeSchema = z.enum(authEventTypes);

export const authEventDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  emailAttempted: z.string().max(255).nullable(),
  eventType: authEventTypeSchema,
  ip: z.string().max(64).nullable(),
  userAgent: z.string().nullable(),
  metadata: z.string().nullable(),
  createdAt: z.string().datetime(),
});

export const authEventQuerySchema = paginationQuerySchema.extend({
  userId: z.string().uuid().optional(),
  eventType: authEventTypeSchema.optional(),
  email: z.string().email().max(255).optional(),
});

export const myAuthEventQuerySchema = paginationQuerySchema.extend({
  eventType: authEventTypeSchema.optional(),
});

export const authEventListSchema = paginatedSchema(authEventDtoSchema);

export type AuthEventDto = z.infer<typeof authEventDtoSchema>;
export type AuthEventQuery = z.infer<typeof authEventQuerySchema>;
export type MyAuthEventQuery = z.infer<typeof myAuthEventQuerySchema>;
